/**
 * File generated by js-routes 2.2.8
 * Based on Rails 7.1.5.1 routes of Hopin::Application
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                module.exports = routes;
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                define([], function () {
                    return routes;
                });
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (keyword_parameters.trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            result += keyword_parameters.anchor
                ? "#" + keyword_parameters.anchor
                : "";
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return false
                ? result
                : encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
        }
    }
    const Utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return Utils.route(parts_table, route_spec, absolute);
        },
    };
    const result = {
        ...__jsr,
        configure: (config) => {
            return Utils.configure(config);
        },
        config: () => {
            return Utils.config();
        },
        serialize: (object) => {
            return Utils.serialize(object);
        },
        ...{},
    };
    Utils.define_module("ESM", result);
    return result;
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /_revision(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const RevisionPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"_revision"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /_version(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const VersionPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"_version"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /events/:id/meetings/accept/:invitation_token(.:format)
 * @param {any} id
 * @param {any} invitationToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acceptMeetingInvitationMeetingsEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"invitation_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"meetings"],[2,[7,"/"],[2,[6,"accept"],[2,[7,"/"],[2,[3,"invitation_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/accept_terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acceptTermsAccountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"accept_terms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/action_cards/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminActionCardPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"action_cards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/action_cards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminActionCardsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"action_cards"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminActivityPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin_users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAdminUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api_tokens/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAPITokenPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api_tokens"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api_tokens(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAPITokensPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api_tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/backstages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBackstagePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"backstages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/backstages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminBackstagesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"backstages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCommentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCommentsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_domains/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCustomDomainPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCustomDomainsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/dashboard_overviews/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDashboardOverviewPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboard_overviews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dashboard_overviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDashboardOverviewsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboard_overviews"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEmailTemplatePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEmailTemplatesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/event_pipeline_jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEventPipelineJobPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"event_pipeline_jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/event_pipeline_jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEventPipelineJobsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"event_pipeline_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/:event_id/registrations/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEventRegistrationPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/:event_id/registrations(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEventRegistrationsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"registrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/event_series/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEventSeriesPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"event_series"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/event_series(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEventSeriesIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"event_series"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/event_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEventTemplatePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"event_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/event_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEventTemplatesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"event_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEventsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/feature_flags_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminFeatureFlagsDashboardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"feature_flags_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/feature_flags_dashboard/update_feature_flag(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminFeatureFlagsDashboardUpdateFeatureFlagPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"feature_flags_dashboard"],[2,[7,"/"],[2,[6,"update_feature_flag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/in_house_archives/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminInHouseArchivePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"in_house_archives"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/integrations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminIntegrationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminIntegrationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/invites/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminInvitePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/invites(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminInvitesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invites"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/line_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminLineItemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"line_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/line_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminLineItemsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"line_items"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/livestream_recordings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminLivestreamRecordingPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"livestream_recordings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/livestream_recordings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminLivestreamRecordingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"livestream_recordings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/opentok_archives/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminOpentokArchivePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"opentok_archives"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminOrderPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminOrdersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminOrganizationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:organization_id/paymentsmigrate(.:format)
 * @param {any} organizationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminOrganizationPaymentsmigratePath = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"paymentsmigrate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:organization_id/paymentsmigrate/migrate(.:format)
 * @param {any} organizationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminOrganizationPaymentsmigrateMigratePath = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"paymentsmigrate"],[2,[7,"/"],[2,[6,"migrate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminOrganizationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/paper_trail_versions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPaperTrailVersionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"paper_trail_versions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/paper_trail_versions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPaperTrailVersionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"paper_trail_versions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/personas/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPersonaPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"personas"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/personas(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPersonasPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"personas"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/promo_codes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPromoCodePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promo_codes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/promo_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPromoCodesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promo_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/recordings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRecordingPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/recording_uploads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRecordingUploadPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"recording_uploads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/recording_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRecordingUploadsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"recording_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/recordings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRecordingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"recordings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/registrations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRegistrationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/registrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRegistrationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registrations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRootPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/series_orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSeriesOrderPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"series_orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/series_orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSeriesOrdersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"series_orders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/sessions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSessionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSessionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/simulives/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSimulivePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"simulives"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/simulives(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSimulivesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"simulives"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/statistics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminStatisticsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/surveys/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSurveyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/surveys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSurveysPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"surveys"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/transaction_logs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTransactionLogPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"transaction_logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/transaction_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTransactionLogsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"transaction_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/transactional_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTransactionalEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"transactional_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/upcoming_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUpcomingEventsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"upcoming_events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/video_channels/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminVideoChannelPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"video_channels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/video_channels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminVideoChannelsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"video_channels"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/webhook_data_subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminWebhookDataSubscriptionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"webhook_data_subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/webhook_data_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminWebhookDataSubscriptionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"webhook_data_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/all_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const allOptionsAdminEventsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"all_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/all_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const allOptionsAdminOrganizationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"all_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/all_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const allOptionsAdminUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"all_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /analytics/area_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyticsAreaInfoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"area_info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /analytics/event_infos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyticsEventInfosPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"event_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /analytics/hidden_user_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyticsHiddenUserIdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"hidden_user_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /analytics/user_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyticsUserInfoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"user_info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/admin/v1/events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiAdminV1EventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/admin/v1/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiAdminV1EventsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/admin/v1/organizations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiAdminV1OrganizationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/admin/v1/organizations/:organization_id/current_payment_plan(.:format)
 * @param {any} organizationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiAdminV1OrganizationCurrentPaymentPlanPath = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"current_payment_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/admin/v1/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiAdminV1OrganizationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/admin/v1/registrations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiAdminV1RegistrationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/admin/v1/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiAdminV1SearchPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/admin/v1/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiAdminV1UserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/admin/v1/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiAdminV1UsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/docs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiDocsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"docs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/docs/pusher(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiDocsPusherPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"pusher"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/plexus(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiPlexusPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"plexus"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/plexus
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiPlexusGraphiQLRailsPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[6,"plexus"]]]]);

/**
 * Generates rails route to
 * /app_store
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const appStoreComponentPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"app_store"]]);

/**
 * Generates rails route to
 * /admin/events/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approveAdminEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organization/:organization_id/apps(/*anything)(.:format)
 * @param {any} organizationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const appsDashboardPath = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"anything":{},"format":{}}, [2,[7,"/"],[2,[6,"organization"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"apps"],[2,[1,[2,[7,"/"],[5,[3,"anything"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/vendors/:id/assign_lead_retrieval_license(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assignLeadRetrievalLicenseOrganisersEventVendorPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_lead_retrieval_license"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/communications/attach_calendar_invite(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachCalendarInviteOrganisersEventCommunicationsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[6,"attach_calendar_invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/new_attendees/attendees_export(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attendeesExportOrganisersEventNewAttendeesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"new_attendees"],[2,[7,"/"],[2,[6,"attendees_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/new_attendees/attendees(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attendeesOrganisersEventNewAttendeesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"new_attendees"],[2,[7,"/"],[2,[6,"attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendors/booths/:id/attendees(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attendeesVendorsBoothPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[6,"booths"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/stripe_connect/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authStripeConnectCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"stripe_connect"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/authenticated(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authenticatedAccountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"authenticated"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/reports/available_reports(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const availableReportsOrganisersEventReportsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"available_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/recordings/backup(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backupOrganisersEventRecordingsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[6,"backup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/admin/v1/reports/:id/ban(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const banAPIAdminV1ReportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ban"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/admin/v1/reports/:id/ban-networking(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const banNetworkingAPIAdminV1ReportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ban-networking"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/ban_user(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const banUserAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ban_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/action_cards/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminActionCardsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"action_cards"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin_users/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminAdminUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_users"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api_tokens/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminAPITokensPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api_tokens"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/backstages/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminBackstagesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"backstages"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_domains/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminCustomDomainsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_domains"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dashboard_overviews/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminDashboardOverviewsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboard_overviews"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_templates/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminEmailTemplatesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_templates"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/event_pipeline_jobs/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminEventPipelineJobsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"event_pipeline_jobs"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/:event_id/registrations/batch_action(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminEventRegistrationsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/event_series/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminEventSeriesIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"event_series"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/event_templates/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminEventTemplatesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"event_templates"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminEventsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/integrations/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminIntegrationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/invites/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminInvitesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/line_items/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminLineItemsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"line_items"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/livestream_recordings/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminLivestreamRecordingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"livestream_recordings"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminOrdersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminOrganizationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/paper_trail_versions/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminPaperTrailVersionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"paper_trail_versions"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/personas/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminPersonasPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"personas"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/promo_codes/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminPromoCodesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promo_codes"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/recording_uploads/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminRecordingUploadsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"recording_uploads"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/recordings/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminRecordingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/registrations/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminRegistrationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/reports/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/series_orders/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminSeriesOrdersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"series_orders"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sessions/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminSessionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/simulives/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminSimulivesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"simulives"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/surveys/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminSurveysPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/transaction_logs/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminTransactionLogsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"transaction_logs"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/transactional_emails/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminTransactionalEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"transactional_emails"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/video_channels/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminVideoChannelsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"video_channels"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/webhook_data_subscriptions/batch_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchActionAdminWebhookDataSubscriptionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"webhook_data_subscriptions"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /webhooks/billing_license_changed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingLicenseChangedWebhooksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"billing_license_changed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/roundtables/bulk_edit_all(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkEditAllOrganisersEventRoundtablesBulkIndexPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"roundtables"],[2,[7,"/"],[2,[6,"bulk_edit_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/roundtables/bulk_edit(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkEditOrganisersEventRoundtablesBulkIndexPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"roundtables"],[2,[7,"/"],[2,[6,"bulk_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cal
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calAPIPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"cal"]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/redeem_codes/cancel(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelOrganisersEventRedeemCodesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"redeem_codes"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/invitations/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelOrganizationsInvitationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /card(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"card"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/edit_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changePasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit_password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /chat(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chatPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chat"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /community(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const communityPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"community"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /company(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/communications/:id/confirm(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmOrganisersEventCommunicationPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/connections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connectionsAccountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"connections"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /contact-sales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contactSalesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contact-sales"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /corporate_redeem/:redeem_code(.:format)
 * @param {any} redeemCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporateRedeemPath = /*#__PURE__*/ __jsr.r({"redeem_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corporate_redeem"],[2,[7,"/"],[2,[3,"redeem_code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /create-demo-event(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createDemoEventPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"create-demo-event"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /create-demo-event/pusher-auth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createDemoEventPusherAuthPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"create-demo-event"],[2,[7,"/"],[2,[6,"pusher-auth"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /create-event(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createEventPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"create-event"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /create-event-wizard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createEventWizardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"create-event-wizard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /create-event-wizard-for-org/:org_id(.:format)
 * @param {any} orgId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createEventWizardForOrgPath = /*#__PURE__*/ __jsr.r({"org_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"create-event-wizard-for-org"],[2,[7,"/"],[2,[3,"org_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /create-event-wizard/*step(.:format)
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createEventWizardStepPath = /*#__PURE__*/ __jsr.r({"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"create-event-wizard"],[2,[7,"/"],[2,[5,[3,"step"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:id/create_ivs_video_channel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createIvsVideoChannelOrganisersEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_ivs_video_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/backstages/:id/create_ivs_video_channel(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createIvsVideoChannelOrganisersEventBackstagePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"backstages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_ivs_video_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/:id/create_report(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createReportAdminEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/reports/create_report(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createReportOrganisersEventReportsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"create_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/backstages/:id/create_rtmp_video_channels(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createRtmpVideoChannelsOrganisersEventBackstagePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"backstages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_rtmp_video_channels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /create_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createTokenPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"create_token"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/create_token(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createTokenAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /session/:event_slug/sign_out(.:format)
 * @param {any} eventSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customDomainSignOutPath = /*#__PURE__*/ __jsr.r({"event_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[3,"event_slug"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/recordings/:id/cuts(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cutsOrganisersEventRecordingPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cuts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/recordings/cuts(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cutsOrganisersEventRecordingsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[6,"cuts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v1/organizations/:id/data_integration_trigger
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataIntegrationTriggerV1OrganizationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"data_integration_trigger"]]]]]]]]);

/**
 * Generates rails route to
 * /magic_links/:redeem_code/decline(.:format)
 * @param {any} redeemCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const declineMagicLinkPath = /*#__PURE__*/ __jsr.r({"redeem_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"magic_links"],[2,[7,"/"],[2,[3,"redeem_code"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/meetings/decline/:invitation_token(.:format)
 * @param {any} id
 * @param {any} invitationToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const declineMeetingInvitationMeetingsEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"invitation_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"meetings"],[2,[7,"/"],[2,[6,"decline"],[2,[7,"/"],[2,[3,"invitation_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /deduct_coupon_amount(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deductCouponAmountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"deduct_coupon_amount"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/events/:id/delete_all_registrations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteAllRegistrationsAdminEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_all_registrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /delete_redeem_code/:redeem_code(.:format)
 * @param {any} redeemCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteRedeemCodePath = /*#__PURE__*/ __jsr.r({"redeem_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"delete_redeem_code"],[2,[7,"/"],[2,[3,"redeem_code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/:event_id/registrations/:id/delete_registration(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteRegistrationAdminEventRegistrationPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/registrations/:id/delete_registration(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deleteRegistrationAdminRegistrationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/communications/deliver(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deliverOrganisersEventCommunicationsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[6,"deliver"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /demo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const demoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"demo"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:id/design(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const designOrganisersEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"design"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyAdminUserSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/:id/download_existing_report(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadExistingReportAdminEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_existing_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/recordings/:id/download(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadOrganisersEventRecordingPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/reports/:job_id/download(.:format)
 * @param {any} eventId
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadOrganisersEventReportsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/action_cards/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminActionCardPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"action_cards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api_tokens/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminAPITokenPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api_tokens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/backstages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminBackstagePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"backstages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_domains/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCustomDomainPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dashboard_overviews/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminDashboardOverviewPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboard_overviews"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/:event_id/registrations/:id/edit(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminEventRegistrationPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/event_series/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminEventSeriesPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"event_series"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/event_templates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminEventTemplatePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"event_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/integrations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminIntegrationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/invites/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminInvitePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/line_items/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminLineItemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"line_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminOrderPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminOrganizationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/paper_trail_versions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminPaperTrailVersionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"paper_trail_versions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/personas/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminPersonaPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"personas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/promo_codes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminPromoCodePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promo_codes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/registrations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminRegistrationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/series_orders/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminSeriesOrderPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"series_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/surveys/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminSurveyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/transaction_logs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminTransactionLogPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"transaction_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/webhook_data_subscriptions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminWebhookDataSubscriptionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"webhook_data_subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /card/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"card"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/event_polls/:id/edit(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editEventEventPollPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"event_polls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /magic_links/:redeem_code/accept(.:format)
 * @param {any} redeemCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editMagicLinkPath = /*#__PURE__*/ __jsr.r({"redeem_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"magic_links"],[2,[7,"/"],[2,[3,"redeem_code"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/applications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOAuthApplicationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganisersEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/announcements/:id/edit(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganisersEventAnnouncementPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/backstages/:id/edit(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganisersEventBackstagePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"backstages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/communications/:id/edit(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganisersEventCommunicationPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/ticketing/:id/edit(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganisersEventPersonaPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"ticketing"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/ticketing/:persona_id/couponing/:id/edit(.:format)
 * @param {any} eventId
 * @param {any} personaId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganisersEventPersonaPersonaCouponPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"persona_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"ticketing"],[2,[7,"/"],[2,[3,"persona_id"],[2,[7,"/"],[2,[6,"couponing"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/registration_fields/:id/edit(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganisersEventRegistrationFieldPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"registration_fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/roundtables/:id/edit(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganisersEventRoundtablePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"roundtables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/schedules/:schedule_id/roundtables/:id/edit(.:format)
 * @param {any} eventId
 * @param {any} scheduleId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganisersEventScheduleRoundtablePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"schedule_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"schedule_id"],[2,[7,"/"],[2,[6,"roundtables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/speakers/:id/edit(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganisersEventSpeakerPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"speakers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/sponsors/:id/edit(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganisersEventSponsorPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"sponsors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/surveys/:id/edit(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganisersEventSurveyPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/schedule/:timetable_id/roundtables/:id/edit(.:format)
 * @param {any} eventId
 * @param {any} timetableId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganisersEventTimetableRoundtablePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"timetable_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"schedule"],[2,[7,"/"],[2,[3,"timetable_id"],[2,[7,"/"],[2,[6,"roundtables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/vendors/:id/edit(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganisersEventVendorPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organization/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organization"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrganizationsUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /posts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPostPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /posts/:post_id/likes/:id/edit(.:format)
 * @param {any} postId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPostLikePath = /*#__PURE__*/ __jsr.r({"post_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"post_id"],[2,[7,"/"],[2,[6,"likes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editUserPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /vendors/booths/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editVendorsBoothPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[6,"booths"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_subscriptions/:registration_ext_id(.:format)
 * @param {any} registrationExtId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emailSubscriptionPath = /*#__PURE__*/ __jsr.r({"registration_ext_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_subscriptions"],[2,[7,"/"],[2,[3,"registration_ext_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise_sso/authenticate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseSsoAuthenticatePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"enterprise_sso"],[2,[7,"/"],[2,[6,"authenticate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise_sso/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseSsoLoginPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"enterprise_sso"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sso_redirect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseSsoRedirectPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sso_redirect"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sso_redirect_canvas(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseSsoRedirectCanvasPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sso_redirect_canvas"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /enterprise_sso/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterpriseSsoSignUpPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"enterprise_sso"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /event_dashboard
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventDashboardComponentPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"event_dashboard"]]);

/**
 * Generates rails route to
 * /event_dashboard/api/events/:event_id/venue_settings(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventDashboardComponentAPIEventVenueSettingsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"event_dashboard"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"venue_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /event_dashboard/api/events/:event_id/marketing_settings(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventDashboardComponentAPIEventMarketingSettingsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"event_dashboard"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"marketing_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /event_dashboard/api/events/:event_id/setup_checklist/visibility(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventDashboardComponentVisibilityAPIEventSetupChecklistPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"event_dashboard"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"setup_checklist"],[2,[7,"/"],[2,[6,"visibility"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /event_dashboard/api/events/:event_id/setup_checklist(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventDashboardComponentAPIEventSetupChecklistPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"event_dashboard"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"setup_checklist"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /event_dashboard/api/events/:event_id/event_links(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventDashboardComponentAPIEventEventLinksPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"event_dashboard"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"event_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /event_dashboard/api/events/:event_id/host_information(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventDashboardComponentAPIEventHostInformationPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"event_dashboard"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"host_information"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /event_dashboard/api/events/:event_id/custom_domain(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventDashboardComponentAPIEventCustomDomainPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"event_dashboard"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"custom_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /event_dashboard/api/events/:event_id/refresh_custom_domain(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventDashboardComponentAPIEventRefreshCustomDomainPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"event_dashboard"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"refresh_custom_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /event_dashboard/api/events/:event_id/publish(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventDashboardComponentAPIEventPublishRootPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"event_dashboard"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /event_dashboard/api/events/:event_id/publish/validation_status(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventDashboardComponentAPIEventPublishValidationPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"event_dashboard"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"publish"],[2,[7,"/"],[2,[6,"validation_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /event_dashboard/api/events/:event_id/profile_categories(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventDashboardComponentAPIEventProfileCategoriesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"event_dashboard"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"profile_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /event_dashboard/api/events/:event_id/clear_chat_jobs(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventDashboardComponentAPIEventClearChatJobsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"event_dashboard"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"clear_chat_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /event_dashboard/api/events/:event_id/clear_chat_jobs/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventDashboardComponentAPIEventClearChatJobPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"event_dashboard"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"clear_chat_jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /event_dashboard/api/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventDashboardComponentAPIEventsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"event_dashboard"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /event_dashboard/api/events/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventDashboardComponentNewAPIEventPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"event_dashboard"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /event_dashboard/api/events/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventDashboardComponentEditAPIEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"event_dashboard"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /event_dashboard/api/events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventDashboardComponentAPIEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"event_dashboard"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /event_dashboard/api/presigned_upload_urls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventDashboardComponentAPIPresignedUploadUrlsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"event_dashboard"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"presigned_upload_urls"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /event_dashboard/api/docs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventDashboardComponentAPIDocsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"event_dashboard"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"docs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/event_polls/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventEventPollPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"event_polls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/event_polls(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventEventPollsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"event_polls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /event_templates
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventTemplatesComponentPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"event_templates"]]);

/**
 * Generates rails route to
 * /event_templates/api/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventTemplatesComponentAPIEventsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"event_templates"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /event_templates/api/templates/:template_id/events(.:format)
 * @param {any} templateId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventTemplatesComponentAPITemplateEventsPath = /*#__PURE__*/ __jsr.r({"template_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"event_templates"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"template_id"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /event_templates/api/docs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventTemplatesComponentAPIDocsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"event_templates"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"docs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /event_wizard
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventWizardComponentPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"event_wizard"]]);

/**
 * Generates rails route to
 * /events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /account/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventsAccountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/registrations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eventsRegistrationsPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"registrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api_tokens/:id/expire(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const expireAdminAPITokenPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api_tokens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"expire"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/redeem_codes/export_csv(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportCsvOrganisersEventRedeemCodesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"redeem_codes"],[2,[7,"/"],[2,[6,"export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/vendors/export_csv(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportCsvOrganisersEventVendorsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[6,"export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/redeem_codes/export_redeem_codes_csv(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportRedeemCodesCsvOrganisersEventRedeemCodesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"redeem_codes"],[2,[7,"/"],[2,[6,"export_redeem_codes_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_install_intent/:oauth_application_external_id(.:format)
 * @param {any} oauthApplicationExternalId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalInstallIntentPath = /*#__PURE__*/ __jsr.r({"oauth_application_external_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_install_intent"],[2,[7,"/"],[2,[3,"oauth_application_external_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /external_install_intent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const externalInstallIntentIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"external_install_intent"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /faq(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const faqPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"faq"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/admin/v1/feature_flags
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const featureFlagsComponentPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[6,"feature_flags"]]]]]]]]);

/**
 * Generates rails route to
 * /api/admin/v1/feature_flags(/:feature_flag_scope)/feature_flags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const featureFlagsComponentFeatureFlagsPath = /*#__PURE__*/ __jsr.r({"feature_flag_scope":{"d":"global"},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[6,"feature_flags"]]]]]]]],[7,"/"]],[3,"feature_flag_scope"]]],[2,[7,"/"],[2,[6,"feature_flags"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /api/admin/v1/feature_flags(/:feature_flag_scope)/feature_flags/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const featureFlagsComponentEditFeatureFlagPath = /*#__PURE__*/ __jsr.r({"feature_flag_scope":{"d":"global"},"id":{"r":true},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[6,"feature_flags"]]]]]]]],[7,"/"]],[3,"feature_flag_scope"]]],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/admin/v1/feature_flags(/:feature_flag_scope)/feature_flags/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const featureFlagsComponentFeatureFlagPath = /*#__PURE__*/ __jsr.r({"feature_flag_scope":{"d":"global"},"id":{"r":true},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[6,"feature_flags"]]]]]]]],[7,"/"]],[3,"feature_flag_scope"]]],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /gdpr_warning/:redeem_code(.:format)
 * @param {any} redeemCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gdprWarningPath = /*#__PURE__*/ __jsr.r({"redeem_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gdpr_warning"],[2,[7,"/"],[2,[3,"redeem_code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /graphql/explorer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const graphqlExplorerPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"graphql"],[2,[7,"/"],[2,[6,"explorer"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /home(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const homePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /hopin_terms_and_conditions/:redeem_code(.:format)
 * @param {any} redeemCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hopinTermsAndConditionsPath = /*#__PURE__*/ __jsr.r({"redeem_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"hopin_terms_and_conditions"],[2,[7,"/"],[2,[3,"redeem_code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /how-it-works(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const howItWorksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"how-it-works"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /hybrid-events-whitepaper(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hybridEventsWhitepaperPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hybrid-events-whitepaper"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /images/presigned_url(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const imagesPresignedUrlPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[6,"presigned_url"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/redeem_codes/import_csv(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importCsvOrganisersEventRedeemCodesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"redeem_codes"],[2,[7,"/"],[2,[6,"import_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organization/:organization_id/integrations(/*anything)(.:format)
 * @param {any} organizationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrationsV2Path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"anything":{},"format":{}}, [2,[7,"/"],[2,[6,"organization"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"integrations"],[2,[1,[2,[7,"/"],[5,[3,"anything"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /invitations/:invitation_id/process_invitation(.:format)
 * @param {any} invitationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitationProcessInvitationPath = /*#__PURE__*/ __jsr.r({"invitation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"invitation_id"],[2,[7,"/"],[2,[6,"process_invitation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sessions/:roundtable_id/speakers/:id/invitation(.:format)
 * @param {any} roundtableId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitationRoundtableSuggestedProfilePath = /*#__PURE__*/ __jsr.r({"roundtable_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[3,"roundtable_id"],[2,[7,"/"],[2,[6,"speakers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"invitation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/redeem_codes/invite_vendor(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inviteVendorOrganisersEventRedeemCodesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"redeem_codes"],[2,[7,"/"],[2,[6,"invite_vendor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/ivs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ivsWebhooksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"ivs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /learn(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const learnPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"learn"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /likes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const likePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"likes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /list-chat-messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const listChatMessagesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"list-chat-messages"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/login_as(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const loginAsAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"login_as"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/login(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const loginEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /magic_links/:redeem_code(.:format)
 * @param {any} redeemCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const magicLinkPath = /*#__PURE__*/ __jsr.r({"redeem_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"magic_links"],[2,[7,"/"],[2,[3,"redeem_code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /manage-events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manageEventsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage-events"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /marketo_lead(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketoLeadPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"marketo_lead"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /match(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const matchPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"match"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:id/meetings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const meetingsOrganisersEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"meetings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /messages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messagePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messagesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/events/:id/migrate_to_bank_questions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const migrateToBankQuestionsAdminEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"migrate_to_bank_questions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/:id/migrate_to_reg_v2(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const migrateToRegV2AdminEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"migrate_to_reg_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /money
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"money"]]);

/**
 * Generates rails route to
 * /money/self_serve/checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentSelfServeCheckoutPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"self_serve"],[2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /money/self_serve/customer_portal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentSelfServeCustomerPortalPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"self_serve"],[2,[7,"/"],[2,[6,"customer_portal"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /money/self_serve/remove_addons/:organization_external_id(.:format)
 * @param {any} organizationExternalId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentSelfServeRemoveAddonsPath = /*#__PURE__*/ __jsr.r({"organization_external_id":{"r":true},"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"self_serve"],[2,[7,"/"],[2,[6,"remove_addons"],[2,[7,"/"],[2,[3,"organization_external_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /money/self_serve/customer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentSelfServeCustomerPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"self_serve"],[2,[7,"/"],[2,[6,"customer"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /money/self_serve/account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentSelfServeAccountPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"self_serve"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /money/self_serve/stripe_connect/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentSelfServeStripeConnectCallbackPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"self_serve"],[2,[7,"/"],[2,[6,"stripe_connect"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /money/self_serve/v2/checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentSelfServeV2CheckoutPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"self_serve"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /money/self_serve/v2/checkout/allowed_countries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentSelfServeV2CheckoutAllowedCountriesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"self_serve"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"allowed_countries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /money/api/plexus(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentAPIPlexusPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"plexus"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /money/api/available_prices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentAPIAvailablePricesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"available_prices"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /money/api/plexus
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentAPIGraphiQLRailsPath = /*#__PURE__*/ __jsr.r({}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[6,"plexus"]]]]);

/**
 * Generates rails route to
 * /money/api/accounts/create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentAPIAccountsCreatePath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /money/api/accounts/license_summary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentAPIAccountsLicenseSummaryPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"license_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /money/api/payments/initiate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentAPIPaymentsInitiatePath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"initiate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /money/api/payments/manage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentAPIPaymentsManagePath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"manage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /money/api/customers_portal/initiate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentAPICustomersPortalInitiatePath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"customers_portal"],[2,[7,"/"],[2,[6,"initiate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /money/api/webhooks/subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentAPIWebhooksSubscriptionsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /money/subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentSubscriptionPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"subscription"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /money/subscription/estimate_checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentSubscriptionEstimateCheckoutPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"estimate_checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /money/subscription/active_subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentSubscriptionActiveSubscriptionPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"active_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /money/webhooks/subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentSubscriptionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /money/webhooks/subscriptions_connect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentSubscriptionsConnectPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"subscriptions_connect"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /money/accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentAccountsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /money/accounts/link_customer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentAccountsLinkCustomerPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"link_customer"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /money/accounts/update_merchant_id(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentAccountsUpdateMerchantIdPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"update_merchant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /money/audit_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentAuditLogsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"audit_logs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /money/billing_periods(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentBillingPeriodsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"billing_periods"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /money/customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentCustomersPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"customers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /money/customers/create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentCustomersCreatePath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"customers"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /money/customers/details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentCustomerDetailsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"customers"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /money/license_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentLicenseTemplatesPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"license_templates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /money/licenses/change(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentLicensesChangePath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"licenses"],[2,[7,"/"],[2,[6,"change"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /money/licenses/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentLicensesCancelPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"licenses"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /money/licenses/add_product(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentLicensesAddProductPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"licenses"],[2,[7,"/"],[2,[6,"add_product"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /money/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentProductsPath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /money/products/create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentProductsCreatePath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"products"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /money/internal/local-transactions/execute(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moneyComponentInternalLocalTransactionsExecutePath = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"money"]],[7,"/"]],[2,[6,"internal"],[2,[7,"/"],[2,[6,"local-transactions"],[2,[7,"/"],[2,[6,"execute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/mute_from_chat(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const muteFromChatPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"mute_from_chat"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/mux(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const muxWebhooksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"mux"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/authorize/native(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nativeOAuthAuthorizationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[2,[7,"/"],[2,[6,"native"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:id/networking(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const networkingOrganisersEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"networking"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/action_cards/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminActionCardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"action_cards"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_domains/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCustomDomainPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dashboard_overviews/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminDashboardOverviewPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboard_overviews"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminEventPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/:event_id/registrations/new(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminEventRegistrationPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/event_series/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminEventSeriesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"event_series"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/integrations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminIntegrationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminOrganizationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/paper_trail_versions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminPaperTrailVersionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"paper_trail_versions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/personas/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminPersonaPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"personas"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/registrations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminRegistrationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/surveys/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminSurveyPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/transaction_logs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminTransactionLogPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"transaction_logs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminUserPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminUserSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /card/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"card"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events/:event_id/event_polls/new(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newEventEventPollPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"event_polls"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/new_login(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLoginEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"new_login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/applications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOAuthApplicationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/backstages/new(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganisersEventBackstagePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"backstages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/ticketing/new(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganisersEventPersonaPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"ticketing"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/ticketing/:persona_id/couponing/new(.:format)
 * @param {any} eventId
 * @param {any} personaId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganisersEventPersonaPersonaCouponPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"persona_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"ticketing"],[2,[7,"/"],[2,[3,"persona_id"],[2,[7,"/"],[2,[6,"couponing"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/registration_fields/new(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganisersEventRegistrationFieldPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"registration_fields"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/roundtables/new(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganisersEventRoundtablePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"roundtables"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/schedules/:schedule_id/roundtables/new(.:format)
 * @param {any} eventId
 * @param {any} scheduleId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganisersEventScheduleRoundtablePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"schedule_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"schedule_id"],[2,[7,"/"],[2,[6,"roundtables"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/speakers/new(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganisersEventSpeakerPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"speakers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/sponsors/new(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganisersEventSponsorPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"sponsors"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/schedule/:timetable_id/roundtables/new(.:format)
 * @param {any} eventId
 * @param {any} timetableId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganisersEventTimetableRoundtablePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"timetable_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"schedule"],[2,[7,"/"],[2,[3,"timetable_id"],[2,[7,"/"],[2,[6,"roundtables"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/vendors/new(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganisersEventVendorPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organization/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organization"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/events/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationsEventPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/invitations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrganizationsInvitationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPostPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /posts/:post_id/likes/new(.:format)
 * @param {any} postId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPostLikePath = /*#__PURE__*/ __jsr.r({"post_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"post_id"],[2,[7,"/"],[2,[6,"likes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRailsConductorInboundEmailPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRailsConductorInboundEmailSourcePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/confirmation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserConfirmationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserRegistrationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/unlock/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserUnlockPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/applications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthApplicationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthApplicationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthAuthorizationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/authorized_applications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthAuthorizedApplicationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorized_applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/authorized_applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthAuthorizedApplicationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorized_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/discovery/keys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthDiscoveryKeysPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"discovery"],[2,[7,"/"],[2,[6,"keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /.well-known/openid-configuration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthDiscoveryProviderPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[2,[6,"openid-configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /.well-known/webfinger(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthDiscoveryWebfingerPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[2,[6,"webfinger"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/introspect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthIntrospectPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"introspect"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/revoke(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthRevokePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthTokenPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/token/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthTokenInfoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"token"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/userinfo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthUserinfoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"userinfo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /_healthcheck
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const okcomputerPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"_healthcheck"]]);

/**
 * Generates rails route to
 * /_healthcheck/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const okcomputerRootPath = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"_healthcheck"]],[7,"/"]]);

/**
 * Generates rails route to
 * /_healthcheck/all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const okcomputerOkcomputerChecksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"_healthcheck"]],[7,"/"]],[2,[6,"all"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /_healthcheck/:check(.:format)
 * @param {any} check
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const okcomputerOkcomputerCheckPath = /*#__PURE__*/ __jsr.r({"check":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"_healthcheck"]],[7,"/"]],[2,[3,"check"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /webhooks/opentok_archive(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const opentokArchiveWebhooksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"opentok_archive"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organiser-billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organiserBillingPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organiser-billing"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organiser-home(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organiserHomePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organiser-home"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organiser-users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organiserUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organiser-users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/attendees_live(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventAnalyticsAttendeesLivePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees_live"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/event_areas(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventAnalyticsEventAreasPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"event_areas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/announcements(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventAnnouncementsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"announcements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/app_area(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventAppAreaPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"app_area"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/attendees/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventAttendeePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/attendees(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventAttendeesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/audience_response_stats(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventAudienceResponseStatsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"audience_response_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/authentication(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventAuthenticationPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"authentication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/average_attendee_rating(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventAverageAttendeeRatingPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"average_attendee_rating"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/average_minutes(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventAverageMinutesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"average_minutes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/backstages/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventBackstagePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"backstages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/backstages(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventBackstagesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"backstages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/badge_designer(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventBadgeDesignerPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"badge_designer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/basics(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventBasicsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"basics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/chat_messages_by_segment(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventChatMessagesBySegmentPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"chat_messages_by_segment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/check_in_area(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventCheckInAreaPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"check_in_area"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/communications/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventCommunicationPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/communications(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventCommunicationsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"communications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/connections(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventConnectionsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"connections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/connections_key_metrics(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventConnectionsKeyMetricsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"connections_key_metrics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/connections_made(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventConnectionsMadePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"connections_made"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/connections_summary(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventConnectionsSummaryPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"connections_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/custom_domain(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventCustomDomainPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"custom_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/custom_domains(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventCustomDomainsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"custom_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/design(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventDesignPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"design"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/duplications(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventDuplicationsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"duplications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/emails(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventEmailsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/engagement_scores(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventEngagementScoresPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"engagement_scores"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/event_details(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventEventDetailsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"event_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/event_polls(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventEventPollsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"event_polls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/event_summary_stats(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventEventSummaryStatsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"event_summary_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/tags/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventEventTagPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/tags(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventEventTagsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/expo_booth_key_metrics(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventExpoBoothKeyMetricsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"expo_booth_key_metrics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/expo_summary(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventExpoSummaryPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"expo_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/floor_plan(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventFloorPlanPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"floor_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/host_information(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventHostInformationPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"host_information"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/kiosk_mode(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventKioskModePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"kiosk_mode"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/latest_connections(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventLatestConnectionsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"latest_connections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/live_analytics(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventLiveAnalyticsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"live_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/marketing(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventMarketingPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"marketing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/meetings_over_time(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventMeetingsOverTimePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"meetings_over_time"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/messages_over_time(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventMessagesOverTimePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"messages_over_time"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/most_active_attendees_by_minutes_spent(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventMostActiveAttendeesByMinutesSpentPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"most_active_attendees_by_minutes_spent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/networking_parts/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventNetworkingPartPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"networking_parts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/new_attendees/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventNewAttendeePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"new_attendees"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/new_attendees(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventNewAttendeesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"new_attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/notices(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventNoticesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"notices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/overview(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventOverviewPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/ticketing/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventPersonaPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"ticketing"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/ticketing/:persona_id/couponing/:id(.:format)
 * @param {any} eventId
 * @param {any} personaId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventPersonaPersonaCouponPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"persona_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"ticketing"],[2,[7,"/"],[2,[3,"persona_id"],[2,[7,"/"],[2,[6,"couponing"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/ticketing/:persona_id/couponing(.:format)
 * @param {any} eventId
 * @param {any} personaId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventPersonaPersonaCouponsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"persona_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"ticketing"],[2,[7,"/"],[2,[3,"persona_id"],[2,[7,"/"],[2,[6,"couponing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/ticketing(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventPersonasPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"ticketing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/pre_event_summary_stats(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventPreEventSummaryStatsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"pre_event_summary_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/recently_registered_attendees(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventRecentlyRegisteredAttendeesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"recently_registered_attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/recordings/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventRecordingPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/recordings(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventRecordingsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"recordings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/redeem_codes/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventRedeemCodePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"redeem_codes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/redeem_codes/:redeem_code_id/resend(.:format)
 * @param {any} eventId
 * @param {any} redeemCodeId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventRedeemCodeResendPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"redeem_code_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"redeem_codes"],[2,[7,"/"],[2,[3,"redeem_code_id"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/redeem_codes(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventRedeemCodesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"redeem_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/refund_amount_over_time(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventRefundAmountOverTimePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"refund_amount_over_time"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/registration_fields/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventRegistrationFieldPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"registration_fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/registration_fields(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventRegistrationFieldsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"registration_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/registration_metrics(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventRegistrationMetricsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"registration_metrics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/registrations_by_country(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventRegistrationsByCountryPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"registrations_by_country"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/registrations_over_time(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventRegistrationsOverTimePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"registrations_over_time"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/registrations_summary(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventRegistrationsSummaryPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"registrations_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/reports/:report_id/regenerate(.:format)
 * @param {any} eventId
 * @param {any} reportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventReportRegeneratePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"regenerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/reports(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventReportsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/roundtables/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventRoundtablePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"roundtables"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/roundtables(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventRoundtablesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"roundtables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/schedules/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventSchedulePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/schedules/:schedule_id/roundtables/:id(.:format)
 * @param {any} eventId
 * @param {any} scheduleId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventScheduleRoundtablePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"schedule_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"schedule_id"],[2,[7,"/"],[2,[6,"roundtables"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/schedules/:schedule_id/roundtables(.:format)
 * @param {any} eventId
 * @param {any} scheduleId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventScheduleRoundtablesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"schedule_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"schedule_id"],[2,[7,"/"],[2,[6,"roundtables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/schedules(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventSchedulesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/session_parts/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventSessionPartPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"session_parts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/setup(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventSetupPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/signatures(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventSignaturesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"signatures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/speakers/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventSpeakerPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"speakers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/speakers(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventSpeakersPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"speakers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/sponsors/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventSponsorPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"sponsors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/sponsors(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventSponsorsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"sponsors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/stage_parts/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventStagePartPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"stage_parts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/streamyard/workspaces(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventStreamyardWorkspacesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"streamyard"],[2,[7,"/"],[2,[6,"workspaces"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/surveys(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventSurveysPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"surveys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/ticket_net_sales(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventTicketNetSalesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"ticket_net_sales"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/ticket_sales_by_type(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventTicketSalesByTypePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"ticket_sales_by_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/ticket_sales_over_time(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventTicketSalesOverTimePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"ticket_sales_over_time"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/schedule/:timetable_id/roundtables/:id(.:format)
 * @param {any} eventId
 * @param {any} timetableId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventTimetableRoundtablePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"timetable_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"schedule"],[2,[7,"/"],[2,[3,"timetable_id"],[2,[7,"/"],[2,[6,"roundtables"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/schedule/:timetable_id/roundtables(.:format)
 * @param {any} eventId
 * @param {any} timetableId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventTimetableRoundtablesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"timetable_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"schedule"],[2,[7,"/"],[2,[3,"timetable_id"],[2,[7,"/"],[2,[6,"roundtables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/top_areas_by_attendees(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventTopAreasByAttendeesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"top_areas_by_attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/top_areas_by_chat_messages(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventTopAreasByChatMessagesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"top_areas_by_chat_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/top_areas_by_current_attendees(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventTopAreasByCurrentAttendeesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"top_areas_by_current_attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/top_attendees_by_expo_booth_interaction(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventTopAttendeesByExpoBoothInteractionPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"top_attendees_by_expo_booth_interaction"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/top_attendees_by_networking_meetings(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventTopAttendeesByNetworkingMeetingsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"top_attendees_by_networking_meetings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/top_expo_booths_by_interaction(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventTopExpoBoothsByInteractionPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"top_expo_booths_by_interaction"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/top_sponsors_by_networking_meetings(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventTopSponsorsByNetworkingMeetingsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"top_sponsors_by_networking_meetings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/analytics_api/events/:event_id/turnout(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventTurnoutPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"analytics_api"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"turnout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/utm_codes(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventUtmCodesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"utm_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/vendors/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventVendorPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/vendors/:vendor_id/vendor_managers/:id(.:format)
 * @param {any} eventId
 * @param {any} vendorId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventVendorRemoveVendorManagerPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"vendor_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[3,"vendor_id"],[2,[7,"/"],[2,[6,"vendor_managers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/vendors(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventVendorsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"vendors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/vendors/bulk_upsert/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventVendorsBulkUpsertPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[6,"bulk_upsert"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/vendors/bulk_upsert(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventVendorsBulkUpsertIndexPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[6,"bulk_upsert"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/venue_controls(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventVenueControlsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"venue_controls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/video_areas(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersEventVideoAreasPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"video_areas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/invitations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisersInvitationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organization(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organization"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organizations/member_authentications.json(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"member_authentications"],[2,[8,"."],[2,[6,"json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/attendees(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsAttendeesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"attendees"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/events/:event_id/assign_admins(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsEventAssignAdminsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"assign_admins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/events/:event_id/manage_admins(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsEventManageAdminsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"manage_admins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/events/:event_id/suggested_profiles/:id(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsEventSuggestedProfilePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"suggested_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/events/:event_id/suggested_profiles(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsEventSuggestedProfilesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"suggested_profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsEventsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsIntegrationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/invitations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsInvitationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/member_authentications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsMemberAuthenticationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"member_authentications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/new_integrations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsNewIntegrationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"new_integrations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/new_integrations/:new_integration_id/install(.:format)
 * @param {any} newIntegrationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsNewIntegrationInstallPath = /*#__PURE__*/ __jsr.r({"new_integration_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"new_integrations"],[2,[7,"/"],[2,[3,"new_integration_id"],[2,[7,"/"],[2,[6,"install"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/new_integrations/:new_integration_id/install_tray(.:format)
 * @param {any} newIntegrationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsNewIntegrationInstallTrayPath = /*#__PURE__*/ __jsr.r({"new_integration_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"new_integrations"],[2,[7,"/"],[2,[3,"new_integration_id"],[2,[7,"/"],[2,[6,"install_tray"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/new_integrations/:new_integration_id/uninstall(.:format)
 * @param {any} newIntegrationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsNewIntegrationUninstallPath = /*#__PURE__*/ __jsr.r({"new_integration_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"new_integrations"],[2,[7,"/"],[2,[3,"new_integration_id"],[2,[7,"/"],[2,[6,"uninstall"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/new_integrations/:new_integration_id/verify(.:format)
 * @param {any} newIntegrationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsNewIntegrationVerifyPath = /*#__PURE__*/ __jsr.r({"new_integration_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"new_integrations"],[2,[7,"/"],[2,[3,"new_integration_id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/new_integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsNewIntegrationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"new_integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsOverviewPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsPaymentPlanPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/registrants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsRegistrantsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"registrants"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /people
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const peopleComponentPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"people"]]);

/**
 * Generates rails route to
 * /people/api
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const peopleComponentPeopleComponentGrapeAPIPath = /*#__PURE__*/ __jsr.r({}, [2,[2,[2,[7,"/"],[6,"people"]],[7,"/"]],[6,"api"]]);

/**
 * Generates rails route to
 * /organisers/events/:id/people(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const peopleOrganisersEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"people"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/space(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroSpacePath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"space"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/space/:relation(.:format)
 * @param {any} relation
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroRelationSpacePath = /*#__PURE__*/ __jsr.r({"database":{},"relation":{"r":true},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"space"],[2,[7,"/"],[2,[3,"relation"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/index_bloat(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroIndexBloatPath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"index_bloat"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/live_queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroLiveQueriesPath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"live_queries"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroQueriesPath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"queries"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/queries/:query_hash(.:format)
 * @param {any} queryHash
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroShowQueryPath = /*#__PURE__*/ __jsr.r({"database":{},"query_hash":{"r":true},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"queries"],[2,[7,"/"],[2,[3,"query_hash"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/system(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroSystemPath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"system"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/cpu_usage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroCpuUsagePath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"cpu_usage"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/connection_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroConnectionStatsPath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"connection_stats"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/replication_lag_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroReplicationLagStatsPath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"replication_lag_stats"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/load_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroLoadStatsPath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"load_stats"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/free_space_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroFreeSpaceStatsPath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"free_space_stats"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/explain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroExplainPath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"explain"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/tune(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroTunePath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"tune"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/connections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroConnectionsPath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"connections"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/maintenance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroMaintenancePath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"maintenance"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/kill(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroKillPath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"kill"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/kill_long_running_queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroKillLongRunningQueriesPath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"kill_long_running_queries"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/kill_all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroKillAllPath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"kill_all"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/enable_query_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroEnableQueryStatsPath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"enable_query_stats"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/reset_query_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroResetQueryStatsPath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"reset_query_stats"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/system_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroSystemStatsPath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"system_stats"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero(/:database)/query_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroQueryStatsPath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[1,[2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[3,"database"]]],[2,[7,"/"],[2,[6,"query_stats"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/pghero/(:database)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pgHeroRootPath = /*#__PURE__*/ __jsr.r({"database":{},"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"pghero"]]]],[7,"/"]],[2,[1,[3,"database"]],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /posts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /posts/:post_id/likes/:id(.:format)
 * @param {any} postId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postLikePath = /*#__PURE__*/ __jsr.r({"post_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"post_id"],[2,[7,"/"],[2,[6,"likes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /posts/:post_id/likes(.:format)
 * @param {any} postId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postLikesPath = /*#__PURE__*/ __jsr.r({"post_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"post_id"],[2,[7,"/"],[2,[6,"likes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewOrganisersEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/announcements/:id/preview(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewOrganisersEventAnnouncementPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/communications/:id/preview(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previewOrganisersEventCommunicationPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sign_in/primary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const primaryChallengePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_in"],[2,[7,"/"],[2,[6,"primary"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /product(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const productPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"product"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /account/profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profileAccountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:id/publish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publishOrganisersEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/reports/pusher_auth(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pusherAuthOrganisersEventReportsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"pusher_auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationPath = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationProxyPath = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inboundEmailId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailIncineratePath = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inboundEmailId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailReroutePath = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailSourcesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDirectUploadsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encodedKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDiskServicePath = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMailgunInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMandrillInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMandrillInboundHealthCheckPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsPostmarkInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsRelayInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsSendgridInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobPath = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobProxyPath = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/reception(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receptionEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reception"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:id/reception_form(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receptionFormOrganisersEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reception_form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /record_match(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recordMatchPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"record_match"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /recordings
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recordingsComponentPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"recordings"]]);

/**
 * Generates rails route to
 * /recordings/api
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recordingsComponentRecordingsComponentRootAPIPath = /*#__PURE__*/ __jsr.r({}, [2,[2,[2,[7,"/"],[6,"recordings"]],[7,"/"]],[6,"api"]]);

/**
 * Generates rails route to
 * /recordings/api/docs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recordingsComponentAPIDocsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"recordings"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"docs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /recruitment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recruitmentPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recruitment"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/redeem_codes/redeem_code_invitations(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const redeemCodeInvitationsOrganisersEventRedeemCodesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"redeem_codes"],[2,[7,"/"],[2,[6,"redeem_code_invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /external_install_intent/:oauth_application_external_id/redirect(.:format)
 * @param {any} oauthApplicationExternalId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const redirectExternalInstallIntentPath = /*#__PURE__*/ __jsr.r({"oauth_application_external_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"external_install_intent"],[2,[7,"/"],[2,[3,"oauth_application_external_id"],[2,[7,"/"],[2,[6,"redirect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/integrations/redirect_to_workos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const redirectToWorkosOrganizationsIntegrationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"redirect_to_workos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/new_integrations/redirect_to_workos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const redirectToWorkosOrganizationsNewIntegrationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"new_integrations"],[2,[7,"/"],[2,[6,"redirect_to_workos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/:event_id/registrations/:id/refund(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refundAdminEventRegistrationPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/registrations/:id/refund(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refundAdminRegistrationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/admin/v1/events/:id/refund(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refundAPIAdminV1EventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/admin/v1/registrations/:id/refund(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refundAPIAdminV1RegistrationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/:id/refund_event(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refundEventAdminEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund_event"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/new_attendees/:id/refund(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refundOrganisersEventNewAttendeePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"new_attendees"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/register(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registerEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /registration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registrationOnboardingPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:id/registration(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registrationOrganisersEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /registrations
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registrationsComponentPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"registrations"]]);

/**
 * Generates rails route to
 * /registrations/api/plexus(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registrationsComponentAPIPlexusPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"registrations"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"plexus"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /registrations/api/plexus
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registrationsComponentAPIGraphiQLRailsPath = /*#__PURE__*/ __jsr.r({}, [2,[2,[2,[7,"/"],[6,"registrations"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[6,"plexus"]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/recordings/rehearsal(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rehearsalOrganisersEventRecordingsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[6,"rehearsal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /magic_links/:redeem_code/reject(.:format)
 * @param {any} redeemCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejectMagicLinkPath = /*#__PURE__*/ __jsr.r({"redeem_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"magic_links"],[2,[7,"/"],[2,[3,"redeem_code"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/video_channels/:id/remove_rtmp_proxy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeRtmpProxyAdminVideoChannelPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"video_channels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_rtmp_proxy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/replay(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const replayEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"replay"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/reports/report_history(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportHistoryOrganisersEventReportsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"report_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/redeem_codes/resend_emails(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resendEmailsOrganisersEventRedeemCodesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"redeem_codes"],[2,[7,"/"],[2,[6,"resend_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/new_attendees/:id/resend_registration_email(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resendRegistrationEmailOrganisersEventNewAttendeePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"new_attendees"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_registration_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/:id/reset_backstage(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetBackstageAdminEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_backstage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id/reset_plan_to_default(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetPlanToDefaultAdminOrganizationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_plan_to_default"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/admin/v1/reports/:id/resolve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolveAPIAdminV1ReportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/restricted(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restrictedEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restricted"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/restricted_logout_warning(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restrictedLogoutWarningEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restricted_logout_warning"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /magic_links/:redeem_code/resubscribe(.:format)
 * @param {any} redeemCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resubscribeMagicLinkPath = /*#__PURE__*/ __jsr.r({"redeem_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"magic_links"],[2,[7,"/"],[2,[3,"redeem_code"],[2,[7,"/"],[2,[6,"resubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/communications/:id/resume(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resumeOrganisersEventCommunicationPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/:id/resync_with_onsite(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resyncWithOnsiteAdminEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resync_with_onsite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/:id/retrieve_stage_recordings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retrieveStageRecordingsAdminEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retrieve_stage_recordings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/retrieve_user_matches(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retrieveUserMatchesEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retrieve_user_matches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/recordings/:id/retrigger_mar_artifacts_generation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retriggerMarArtifactsGenerationAdminRecordingPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retrigger_mar_artifacts_generation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/announcements/:id/review(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewOrganisersEventAnnouncementPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id/rollback_organization_from_enterprise(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rollbackOrganizationFromEnterpriseAdminOrganizationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rollback_organization_from_enterprise"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rootPath = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /api
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rootAPIPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"api"]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/schedules/:schedule_id/roundtables/:id/rtmp_details(.:format)
 * @param {any} eventId
 * @param {any} scheduleId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rtmpDetailsOrganisersEventScheduleRoundtablePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"schedule_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[3,"schedule_id"],[2,[7,"/"],[2,[6,"roundtables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rtmp_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/schedule/:timetable_id/roundtables/:id/rtmp_details(.:format)
 * @param {any} eventId
 * @param {any} timetableId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rtmpDetailsOrganisersEventTimetableRoundtablePath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"timetable_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"schedule"],[2,[7,"/"],[2,[3,"timetable_id"],[2,[7,"/"],[2,[6,"roundtables"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rtmp_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/redeem_codes/sample_csv(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sampleCsvOrganisersEventRedeemCodesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"redeem_codes"],[2,[7,"/"],[2,[6,"sample_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /schedules
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedulesComponentPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"schedules"]]);

/**
 * Generates rails route to
 * /schedules/api/plexus(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedulesComponentAPIPlexusPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"schedules"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"plexus"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /schedules/api/plexus
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedulesComponentAPIGraphiQLRailsPath = /*#__PURE__*/ __jsr.r({}, [2,[2,[2,[7,"/"],[6,"schedules"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[6,"plexus"]]]]);

/**
 * Generates rails route to
 * /sign_in/secondary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const secondaryChallengePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_in"],[2,[7,"/"],[2,[6,"secondary"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:id/segments(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const segmentsOrganisersEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"segments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/redeem_codes/send_emails(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendEmailsOrganisersEventRedeemCodesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"redeem_codes"],[2,[7,"/"],[2,[6,"send_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/redeem_codes/send_redeem_codes_email(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendRedeemCodesEmailOrganisersEventRedeemCodesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"redeem_codes"],[2,[7,"/"],[2,[6,"send_redeem_codes_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/redeem_codes/send_test_email(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendTestEmailOrganisersEventRedeemCodesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"redeem_codes"],[2,[7,"/"],[2,[6,"send_test_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/sendgrid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendgridWebhooksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"sendgrid"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/session_recording(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sessionRecordingWebhooksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"session_recording"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /session/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sessionSignOutPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events/:id/set_utm_cookie(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setUtmCookieEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_utm_cookie"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sidekiqWebPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"sidekiq"]]]]);

/**
 * Generates rails route to
 * /sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signInPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sign_in/primary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signInPrimaryPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_in"],[2,[7,"/"],[2,[6,"primary"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sign_in/secondary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signInSecondaryPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_in"],[2,[7,"/"],[2,[6,"secondary"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signOutPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signUpPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sign_up_consents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signUpConsentsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_up_consents"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /webhooks/simulive/:simulive_uuid/end(.:format)
 * @param {any} simuliveUuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const simuliveEndedWebhooksPath = /*#__PURE__*/ __jsr.r({"simulive_uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"simulive"],[2,[7,"/"],[2,[3,"simulive_uuid"],[2,[7,"/"],[2,[6,"end"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sitemap(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemapPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sitemap"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sitemap-corporate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemapCorporatePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sitemap-corporate"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sitemap-events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemapEventsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sitemap-events"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sitemap.xml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemapIndexPath = /*#__PURE__*/ __jsr.r({"format":{"d":"xml"}}, [2,[7,"/"],[2,[6,"sitemap"],[2,[8,"."],[2,[6,"xml"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /social_login_signup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const socialLoginSignupPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"social_login_signup"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sign_in/social_sso(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const socialSsoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_in"],[2,[7,"/"],[2,[6,"social_sso"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/reports/status(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statusOrganisersEventReportsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/communications/:id/stop(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stopOrganisersEventCommunicationPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"stop"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/stream_chat(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const streamChatWebhooksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"stream_chat"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /streamyard/chat_credentials(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const streamyardChatCredentialsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"streamyard"],[2,[7,"/"],[2,[6,"chat_credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/stripe-connect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeConnectWebhooksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"stripe-connect"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /stripe-webhooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeWebhooksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stripe-webhooks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/claim_ticket(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submitUsersClaimTicketPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"claim_ticket"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/communications/suppress(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suppressOrganisersEventCommunicationsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[6,"suppress"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/admin/v1/reports/:id/suspend(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suspendAPIAdminV1ReportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"suspend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/switch_organization(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switchOrganizationAccountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"switch_organization"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/communications/:id/test(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const testOrganisersEventCommunicationPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:id/text(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const textOrganisersEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"text"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id/toggle_integration(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleIntegrationAdminOrganizationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/video_channels/:id/toggle_stream_source(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleStreamSourceAdminVideoChannelPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"video_channels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_stream_source"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/:id/trigger_matchmaking_data_backfill(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const triggerMatchmakingDataBackfillAdminEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"trigger_matchmaking_data_backfill"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/recordings/:id/trim(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trimOrganisersEventRecordingPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"trim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/unban_user(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unbanUserAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unban_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:id/unblock_user/:registration_id(.:format)
 * @param {any} id
 * @param {any} registrationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unblockUserOrganisersEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"registration_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unblock_user"],[2,[7,"/"],[2,[3,"registration_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api_tokens/:id/unexpire(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unexpireAdminAPITokenPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api_tokens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unexpire"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organization/unlink_stripe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlinkStripeOrganizationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organization"],[2,[7,"/"],[2,[6,"unlink_stripe"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/admin/v1/reports/:id/unresolve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unresolveAPIAdminV1ReportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unresolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /magic_links/:redeem_code/unsubscribe(.:format)
 * @param {any} redeemCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribeMagicLinkPath = /*#__PURE__*/ __jsr.r({"redeem_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"magic_links"],[2,[7,"/"],[2,[3,"redeem_code"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/:id/update_feature_flag(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateFeatureFlagAdminEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_feature_flag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id/update_feature_flag(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateFeatureFlagAdminOrganizationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_feature_flag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/update_feature_flag(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateFeatureFlagAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_feature_flag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/ticketing/:id/update_persona_matches(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePersonaMatchesOrganisersEventPersonaPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"ticketing"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_persona_matches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organization/update_picture(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePictureOrganizationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organization"],[2,[7,"/"],[2,[6,"update_picture"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/communications/:id/update_preview(.:format)
 * @param {any} eventId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePreviewOrganisersEventCommunicationPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"communications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encodedToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateRailsDiskServicePath = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account/upload_s3_policy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadS3PolicyAccountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"upload_s3_policy"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:id/upload_s3_policy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadS3PolicyOrganisersEventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upload_s3_policy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /vendors/booths/:id/upload_s3_policy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadS3PolicyVendorsBoothPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[6,"booths"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upload_s3_policy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/recordings/uploads(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadsOrganisersEventRecordingsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"recordings"],[2,[7,"/"],[2,[6,"uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /url_clicks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const urlClickPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"url_clicks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /use-cases(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const useCasesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"use-cases"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/auth/apple(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userAppleOmniauthAuthorizePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"apple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/apple/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userAppleOmniauthCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"apple"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userConfirmationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/facebook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userFacebookOmniauthAuthorizePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"facebook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/facebook/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userFacebookOmniauthCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"facebook"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/google_oauth2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userGoogleOauth2OmniauthAuthorizePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_oauth2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/google_oauth2/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userGoogleOauth2OmniauthCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_oauth2"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/linkedin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userLinkedinOmniauthAuthorizePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"linkedin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/linkedin/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userLinkedinOmniauthCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"linkedin"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/ring_central(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userRingCentralOmniauthAuthorizePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"ring_central"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/ring_central/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userRingCentralOmniauthCallbackPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"ring_central"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/unlock(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userUnlockPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/appear(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersAppearPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"appear"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/apple/callback_post(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersAuthAppleCallbackPostPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"apple"],[2,[7,"/"],[2,[6,"callback_post"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/facebook/oauth/client_code(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersAuthFacebookOAuthClientCodePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"facebook"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"client_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/google_id_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersAuthGoogleIdTokenPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_id_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/basic_profiles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersBasicProfilesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"basic_profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/change_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersChangePasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"change_password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/check_sso_login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersCheckSsoLoginPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"check_sso_login"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/checkin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersCheckinPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"checkin"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/claim_ticket/:invite_token(.:format)
 * @param {any} inviteToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersClaimTicketPath = /*#__PURE__*/ __jsr.r({"invite_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"claim_ticket"],[2,[7,"/"],[2,[3,"invite_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/disappear(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersDisappearPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"disappear"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/like(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersLikePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"like"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/resend_confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersResendConfirmationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"resend_confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/room_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersRoomDetailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"room_details"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/scoped_sso(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersScopedSsoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"scoped_sso"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/set_available(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersSetAvailablePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"set_available"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/set_in_session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersSetInSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"set_in_session"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/set_not_in_room(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersSetNotInRoomPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"set_not_in_room"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/set_unavailable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersSetUnavailablePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"set_unavailable"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersSignOutPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sso(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersSsoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /v1/booths/:booth_id/tags
 * @param {any} boothId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1BoothTagsPath = /*#__PURE__*/ __jsr.r({"booth_id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"booths"],[2,[7,"/"],[2,[3,"booth_id"],[2,[7,"/"],[6,"tags"]]]]]]]]);

/**
 * Generates rails route to
 * /v1/docs
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1DocsPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[6,"docs"]]]]);

/**
 * Generates rails route to
 * /v1/events/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1EventPath = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[3,"id"]]]]]]);

/**
 * Generates rails route to
 * /v1/events/:event_id/booths
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1EventBoothsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[6,"booths"]]]]]]]]);

/**
 * Generates rails route to
 * /v1/events/:event_id/dataSubscriptions
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1EventDataSubscriptionsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[6,"dataSubscriptions"]]]]]]]]);

/**
 * Generates rails route to
 * /v1/events/:event_id/duplications
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1EventDuplicationsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[6,"duplications"]]]]]]]]);

/**
 * Generates rails route to
 * /v1/events/:event_id/registrations
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1EventRegistrationsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[6,"registrations"]]]]]]]]);

/**
 * Generates rails route to
 * /v1/events/:event_id/reports
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1EventReportsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[6,"reports"]]]]]]]]);

/**
 * Generates rails route to
 * /v1/events/:event_id/scheduleItems
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1EventScheduleItemsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[6,"scheduleItems"]]]]]]]]);

/**
 * Generates rails route to
 * /v1/events/:event_id/sessions
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1EventSessionsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[6,"sessions"]]]]]]]]);

/**
 * Generates rails route to
 * /v1/events/:event_id/stages
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1EventStagesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[6,"stages"]]]]]]]]);

/**
 * Generates rails route to
 * /v1/events/:event_id/tickets
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1EventTicketsPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[6,"tickets"]]]]]]]]);

/**
 * Generates rails route to
 * /v1/health
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1HealthIndexPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[6,"health"]]]]);

/**
 * Generates rails route to
 * /v1/magicLinks/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1MagicLinkPath = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"magicLinks"],[2,[7,"/"],[3,"id"]]]]]]);

/**
 * Generates rails route to
 * /v1/*path
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1NotFoundPath = /*#__PURE__*/ __jsr.r({"path":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[5,[3,"path"]]]]]);

/**
 * Generates rails route to
 * /v1/organizations/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1OrganizationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[3,"id"]]]]]]);

/**
 * Generates rails route to
 * /v1/organizations/:organization_id/bankQuestions
 * @param {any} organizationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1OrganizationBankquestionsPath = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[6,"bankQuestions"]]]]]]]]);

/**
 * Generates rails route to
 * /v1/organizations/:organization_id/events
 * @param {any} organizationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1OrganizationEventsPath = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[6,"events"]]]]]]]]);

/**
 * Generates rails route to
 * /v1/organizations/:organization_id/templates
 * @param {any} organizationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1OrganizationTemplatesPath = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[6,"templates"]]]]]]]]);

/**
 * Generates rails route to
 * /v1/organizations
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1OrganizationsPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[6,"organizations"]]]]);

/**
 * Generates rails route to
 * /v1/magic_link
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1RedeemCodeIndexPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[6,"magic_link"]]]]);

/**
 * Generates rails route to
 * /v1/registrations/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1RegistrationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[3,"id"]]]]]]);

/**
 * Generates rails route to
 * /v1/reports/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1ReportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[3,"id"]]]]]]);

/**
 * Generates rails route to
 * /v1/reports/:report_id/download
 * @param {any} reportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1ReportDownloadPath = /*#__PURE__*/ __jsr.r({"report_id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[6,"download"]]]]]]]]);

/**
 * Generates rails route to
 * /v1/scheduleItems/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1ScheduleItemPath = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scheduleItems"],[2,[7,"/"],[3,"id"]]]]]]);

/**
 * Generates rails route to
 * /v1/scheduleItems/:schedule_item_id/tags
 * @param {any} scheduleItemId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1ScheduleItemTagsPath = /*#__PURE__*/ __jsr.r({"schedule_item_id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scheduleItems"],[2,[7,"/"],[2,[3,"schedule_item_id"],[2,[7,"/"],[6,"tags"]]]]]]]]);

/**
 * Generates rails route to
 * /v1/templates/:template_id/event
 * @param {any} templateId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1TemplateEventsPath = /*#__PURE__*/ __jsr.r({"template_id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"template_id"],[2,[7,"/"],[6,"event"]]]]]]]]);

/**
 * Generates rails route to
 * /v1/tickets/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1TicketPath = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[3,"id"]]]]]]);

/**
 * Generates rails route to
 * /v1/tickets/:ticket_id/bankQuestions
 * @param {any} ticketId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1TicketBankQuestionsPath = /*#__PURE__*/ __jsr.r({"ticket_id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"ticket_id"],[2,[7,"/"],[6,"bankQuestions"]]]]]]]]);

/**
 * Generates rails route to
 * /v1/tickets/:ticket_id/magicLinks
 * @param {any} ticketId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1TicketMagicLinksPath = /*#__PURE__*/ __jsr.r({"ticket_id":{"r":true}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tickets"],[2,[7,"/"],[2,[3,"ticket_id"],[2,[7,"/"],[6,"magicLinks"]]]]]]]]);

/**
 * Generates rails route to
 * /magic_links/:redeem_code/validate_identity(.:format)
 * @param {any} redeemCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validateIdentityMagicLinkPath = /*#__PURE__*/ __jsr.r({"redeem_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"magic_links"],[2,[7,"/"],[2,[3,"redeem_code"],[2,[7,"/"],[2,[6,"validate_identity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /vendors/booths/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorsBoothPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[6,"booths"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /vendors/booths(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorsBoothsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vendors"],[2,[7,"/"],[2,[6,"booths"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/redeem_codes/vendors(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendorsOrganisersEventRedeemCodesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"redeem_codes"],[2,[7,"/"],[2,[6,"vendors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /organizations/integrations/verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verifyOrganizationsIntegrationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /magic_links/:redeem_code/version(.:format)
 * @param {any} redeemCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const versionMagicLinkPath = /*#__PURE__*/ __jsr.r({"redeem_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"magic_links"],[2,[7,"/"],[2,[3,"redeem_code"],[2,[7,"/"],[2,[6,"version"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organisers/events/:event_id/new_attendees/waitlist(.:format)
 * @param {any} eventId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const waitlistOrganisersEventNewAttendeesPath = /*#__PURE__*/ __jsr.r({"event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organisers"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"event_id"],[2,[7,"/"],[2,[6,"new_attendees"],[2,[7,"/"],[2,[6,"waitlist"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/admin/v1/reports/:id/warn(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const warnAPIAdminV1ReportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"warn"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/hopin_video(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooksHopinVideoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"hopin_video"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /whitepaper(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const whitepaperPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"whitepaper"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /widget_sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const widgetSignInPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"widget_sign_in"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /widget_sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const widgetSignOutPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"widget_sign_out"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /zendesk/sso(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const zendeskSsoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"zendesk"],[2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /zendesk/widget/messenger(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const zendeskWidgetMessengerPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"zendesk"],[2,[7,"/"],[2,[6,"widget"],[2,[7,"/"],[2,[6,"messenger"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

